import {
  InstallmentsText,
  OptionDescriptionText,
  OptionTitleText,
  TextDiv,
} from '@screens/checkout/paymentMethod/styles/PaymentsOptions.styles';
import {
  DivisionLine,
  PaymentMethodItem,
  RootDiv,
  TitleTypography,
} from '../styles/ProductsList.styles';
import { PaymentMethod } from '@interfaces';
import { usePermissions } from '@hooks/usePermissions';
import { CardIcon } from '@screens/checkout/paymentMethod/components/CardIcon';
import { PaymentMethodTexts } from '../helpers/PaymentMethodTexts';
import { useOrderState } from '@hooks/useOrderState';

interface PaymentMethodDetailsProps {
  paymentMethod: PaymentMethod;
  creditsUsed?: string;
  hideHeader?: boolean;
  hideInstallments?: boolean;
}

const paymentMethodTypes = {
  CASH: 'Efectivo',
  CARD: 'Tarjeta',
  TRANSFER: 'Transferencia',
  CARD_CASH: 'Tarjeta + Efectivo',
};

export function PaymentMethodDetails(props: PaymentMethodDetailsProps) {
  const { paymentMethod, creditsUsed, hideHeader, hideInstallments } = props;

  const { userCan } = usePermissions();
  const isAssistantUser = userCan('MANAGE_USER');
  const isLocalVendor = userCan('LOCAL_VENDOR');

  const { order } = useOrderState();

  const localPaymentMethod = order?.metadata?.localVendor?.paymentMethod;
  const assistantPaymentMethod =
    order?.metadata?.assistantVendor?.paymentMethod;

  const isClient =
    !(isLocalVendor && localPaymentMethod) &&
    !(isAssistantUser && assistantPaymentMethod);

  const paymentMethodText = PaymentMethodTexts({ paymentMethod, creditsUsed });

  return (
    <RootDiv>
      {!hideHeader && (
        <>
          <TitleTypography> Método de pago seleccionado </TitleTypography>
          <DivisionLine />
        </>
      )}
      <PaymentMethodItem>
        {paymentMethod?.type === 'FINTOC' ? (
          <CardIcon creditCardType="Fintoc" />
        ) : paymentMethod?.type === 'BANCO_ESTADO' ? (
          <CardIcon creditCardType="BancoEstado" />
        ) : (
          <CardIcon
            creditCardType={paymentMethod?.data?.creditCardType as string}
          />
        )}

        <TextDiv>
          {isClient && (
            <>
              <OptionTitleText>{paymentMethodText?.title}</OptionTitleText>
              <OptionDescriptionText light>
                {paymentMethodText?.description}
              </OptionDescriptionText>
            </>
          )}

          {isLocalVendor && (
            <>
              <OptionTitleText>Venta en local</OptionTitleText>
              <OptionDescriptionText light>
                {paymentMethodTypes[localPaymentMethod]}
              </OptionDescriptionText>
            </>
          )}

          {isAssistantUser && (
            <>
              <OptionTitleText>Pago por asistente</OptionTitleText>
              <OptionDescriptionText light>
                {paymentMethodTypes[assistantPaymentMethod]}
              </OptionDescriptionText>
            </>
          )}

          {!hideInstallments && order?.metadata?.installments > 1 && (
            <>
              <InstallmentsText>
                {order?.metadata?.installments} cuotas
              </InstallmentsText>
            </>
          )}
        </TextDiv>
      </PaymentMethodItem>
    </RootDiv>
  );
}
